import { z } from "zod";

import { airportSchema, flightSearchSchema } from "@/feature/flight/search/schema/search";

export type TAirport = z.infer<typeof airportSchema>;
export type TFlightSearchFormData = z.infer<typeof flightSearchSchema>;
export type TTripType = TFlightSearchFormData["tripType"];
export type TPassengerCounts = TFlightSearchFormData["passengers"];
export type TFlightSegment = TFlightSearchFormData["flights"][number];

export interface IDecodedFlightSearch extends TFlightSearchFormData {
  isValid: boolean;
  validationErrors: string[];
}

export const DEFAULT_FLIGHT_FORM_VALUES: TFlightSearchFormData = {
  tripType: "oneway",
  fareType: "regularFare",
  passengers: { adults: 1, children: 0, infants: 0 },
  cabin: "1",
  childrenAges: [],
  flights: [
    {
      from: {
        iata_code: "LHR",
        name: "Heathrow Airport",
        city_name: "London",
        country: "UNITED KINGDOM",
        latitude: 51.47002,
        longitude: -0.454295,
      },
      to: {
        iata_code: "DXB",
        name: "Dubai International Airport",
        city_name: "Dubai",
        country: "UNITED ARAB EMIRATES",
        latitude: 25.253174,
        longitude: 55.365673,
      },
    }
  ],
};
